import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { get } from 'lodash';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';
import TextAreaField from 'shared-components/reduxForms/fields/TextAreaField/TextAreaField';
import validateSoundForm from './forms/validateSoundForm';
import onSubmitProductionForms from './forms/onSubmitProductionForms';
import { mapBoolToString } from './data/utils';
import ButtonNavigation from '../app-faq-components/ButtonNavigation';
import { FormattedMessage, defineMessages, injectIntl, intlShape } from 'react-intl';

const SoundForm = ({
  error,
  handleSubmit,
  intl,
  ...props
}) => {
  const translationMessages = defineMessages({
    yes: {
      id: 'hosting.sound_form.yes',
      defaultMessage: 'Yes'
    },
    no: {
      id: 'hosting.sound_form.no',
      defaultMessage: 'No'
    }
  });
  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <h2><FormattedMessage id="hosting.sound_form.heading" defaultMessage="Sound"/></h2>
      <p className="text-gray-600"><FormattedMessage id="hosting.sound_form.sound_text" defaultMessage="Many video shoots will want to record audio in your space. Give them a sense of what the noise level is like."/></p>
      <div className="questions-section">
        <h6><FormattedMessage id="hosting.sound_form.soundproofing_availability" defaultMessage="Does your space have soundproofing?"/></h6>
        <Field
          name='has_soundproofing'
          component={ToggleField}
          attributes={{
            'data-testing-id': 'has_soundproofing'
          }}
          firstOption={
            {
              id: 'has_soundproofing_true',
              value: 'true',
              label: intl.formatMessage(translationMessages.yes)
            }}
          secondOption={
            {
              id: 'has_soundproofing_false',
              value: 'false',
              label: intl.formatMessage(translationMessages.no)
            }}
        />
      </div>
      <div className="questions-section">
        <h6 className="heavy"><FormattedMessage id="hosting.sound_form.ambient_noise_description_heading" defaultMessage="Describe the ambient noise in your space"/></h6>
        <ul className="list-style-inside no-gutter text-gray-600 margin-lg-bottom">
          <li><FormattedMessage id="hosting.sound_form.neighbors" defaultMessage="Can you hear neighbors?"/></li>
          <li><FormattedMessage id="hosting.sound_form.busy_street" defaultMessage="Are you on a busy street?"/></li>
          <li><FormattedMessage id="hosting.sound_form.appliances_noise" defaultMessage="Any noise from appliances or AC?"/></li>
        </ul>
        <Field
          name='ambient_noise_description'
          component={TextAreaField}
          attributes={{
            'data-testing-id': 'ambient_noise_description'
          }}
          maxLength={1000}
        />
      </div>
      <hr className="space-type-line-break"/>
      <div className="text-danger text-small margin-xl-bottom">{error}</div>
      <ButtonNavigation {...props} />
    </form>
  );
};

SoundForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  insuranceToggle: PropTypes.bool,
  moveFurnitureToggle: PropTypes.bool,
  spaceId: PropTypes.string,
  intl: intlShape
};

const config = {
  form: 'PRODUCTION_SOUND_FORM',
  onSubmit: onSubmitProductionForms,
  validate: validateSoundForm
};

function mapStateToProps (state) {
  const productionDetails = get(state, 'space.data.production_details', {});

  return {
    initialValues: {
      ...mapBoolToString(productionDetails)
    }
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(SoundForm)));
